var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullstory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.224,
    y1: -10.224,
    x2: -9.888,
    y2: 75.888,
    gradientTransform: "matrix(1 0 0 -1 0 66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D44B92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F0617D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3874A"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 64,
    height: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,53.8c2.2,1.5,5.8,2.4,9.3,2.4c6.5,0,11.4-2.8,11.4-9.1c0-5.4-3-8-9.9-9.5c-3.5-0.9-4.8-2-4.8-3.9 s1.6-3.4,4.5-3.4c3.2,0,5.8,1.1,8.4,3v-6.1C46,25.7,43.3,25,39.9,25c-6.1,0-10.8,3-10.8,9.1c0,5.2,2.7,7.7,8.9,9.1 c3.9,1,5.7,1.9,5.7,4.3c0,2.4-2,3.4-5,3.4c-3.1,0-6.4-1.3-9.2-3.4L29.6,53.8z M28.2,31.3h-3.1v24.3h-6.7V31.3h-4.7v-5.6h4.7V20 C18.4,12.6,22.5,9,28.9,9c2.4,0,4.2,0.5,5.9,1.5v6.1c-1.6-1.1-3.1-1.7-5.2-1.7c-2.9,0-4.5,1.4-4.5,5.1v5.7h7.3 C30.2,26.8,28.7,28.8,28.2,31.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullstory);
export default __webpack_public_path__ + "static/media/fullstory.dec55c9b0112ca62224560d01bd5b43a.svg";
export { ForwardRef as ReactComponent };